import { render, staticRenderFns } from "./Remitters.vue?vue&type=template&id=454b976a"
import script from "./Remitters.vue?vue&type=script&lang=js"
export * from "./Remitters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports